import React, { useEffect, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { Container } from "react-bootstrap";
import SearchComponent from "./CommanSearch";
import { useDispatch, useSelector } from "react-redux";
import {
  editAdminDetails,
  getAdminDetails,
  getSongReqMark,
  getSongReqNotify,
  uploadFile,
} from "../Redux/Actions/auth";
import { capitalize } from "../Utils/commonFiles";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  getNotificationList,
  markNotificationRead,
} from "../Redux/Actions/NotificationActions";
import { Encryptedid } from "../Utils/bcrypt";

const TopHeader = ({ hideUnhide, handleUnread, unreadReq, handleUnreadChange }) => {
  const getInfo = useSelector((e) => e.userAuth.adminDetail);
  const getNotificationlist = useSelector((e) => e.notification.notificationList);

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const pathname = location.pathname;

  const [selectedFile, setSelectedFile] = useState(null);
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    if (getNotificationlist && getNotificationlist.length > 0) {
      setNotifications(
        getNotificationlist.map((item) => ({
          ...item,
          isRead: item.isRead || false,
        }))
      );
    } else {
      setNotifications([]);
    }
  }, [getNotificationlist]);

  const shouldHideSearch = (pathname) => {
    const hiddenPaths = [
      /^\/client-detail\/[a-zA-Z0-9+/=]+$/,
      /^\/events-details\/[a-zA-Z0-9+/=]+$/,
      /^\/events$/,
      /^\/presets$/,
      /^\/faqs$/,
      /^\/resources$/,
      /^\/messages$/,
      /^\/location$/,
      /^\/changepassword$/,
    ];

    return hiddenPaths.some((pattern) =>
      typeof pattern === "string"
        ? pathname === pattern
        : pattern.test(pathname)
    );
  };

  const shouldShowBack = (pathname) => {
    const hiddenPaths = [
      /^\/client-detail\/[a-zA-Z0-9+/=]+$/,
      /^\/events-details\/[a-zA-Z0-9+/=]+$/,
    ];

    return hiddenPaths.some((pattern) =>
      typeof pattern === "string"
        ? pathname === pattern
        : pattern.test(pathname)
    );
  };

  const getHeading = (pathname) => {
    const headings = [
      {
        pattern: /^\/client-detail\/[a-zA-Z0-9+/=]+$/,
        heading: "Client Detail",
      },
      {
        pattern: /^\/events-details\/[a-zA-Z0-9+/=]+$/,
        heading: "Event Details",
      },
      { pattern: /^\/events$/, heading: "Events" },
      { pattern: /^\/dashboard$/, heading: "Dashboard" },
      { pattern: /^\/clients$/, heading: "Clients" },
      { pattern: /^\/songs$/, heading: "Songs" },
      { pattern: /^\/songrequest$/, heading: "Song Requests" },
      { pattern: /^\/requestchanges$/, heading: "Change Requests" },
      { pattern: /^\/users$/, heading: "Registered Interest" },
      { pattern: /^\/administrators$/, heading: "Administrators" },
      { pattern: /^\/transactions$/, heading: "Transactions" },
      { pattern: /^\/messages$/, heading: "Messages" },
      { pattern: /^\/resources$/, heading: "Resources" },
      { pattern: /^\/faqs$/, heading: "Faqs" },
      { pattern: /^\/presets$/, heading: "Event Presets" },
      { pattern: /^\/location$/, heading: "Location" },
      { pattern: /^\/changepassword$/, heading: "Change Password" },
      { pattern: /^\/referralsource$/, heading: "Referral Source" },
    ];

    const matchedHeading = headings.find(({ pattern }) =>
      typeof pattern === "string"
        ? pathname === pattern
        : pattern.test(pathname)
    );
    return matchedHeading ? matchedHeading.heading : "";
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
      handleUploadFile(file);
    }
  };

  const handleUploadFile = async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    let data = {
      fullName: getInfo?.fullName,
    };
    if (file) {
      const apiRes = await dispatch(uploadFile(formData));
      data["image"] = apiRes.payload.data.url;
    }
    try {
      await dispatch(editAdminDetails(data)).then((res) => {
        if (res?.payload?.statusCode === 200) {
          dispatch(getAdminDetails())
        }
      })
    } catch (error) { }
  };

  useEffect(() => {
    dispatch(getNotificationList());
    dispatch(getSongReqNotify()).then((e) => {
      if (e?.payload?.statusCode === 200) {
        handleUnread(true)
      } else {
        handleUnread(false)
      }
    });
      dispatch(getSongReqMark()).then((e) => {
      if (e?.payload?.statusCode === 200) {
       debugger
        handleUnreadChange(true)
      } else {
        handleUnreadChange(false)
      }
    });
    dispatch(getAdminDetails()).then((res) => {
      if (res?.payload?.success === true || res?.payload?.success === false) {
      }
    });
  }, [dispatch]);

  const hasUnreadNotifications = notifications.some(
    (notification) => !notification.isRead
  );

  const markAsRead = (index, id) => {
    const updatedNotifications = [...notifications];

    if (!updatedNotifications[index].isRead) {
      updatedNotifications[index].isRead = true;
      setNotifications(updatedNotifications);
      dispatch(markNotificationRead({ notificationId: id }));
    }
  };

  return (
    <div>
      <Container fluid>
        <div className="dashboard-items mt-3">
          <div className="commn-top-header">
            <div className="title-w-back">
              {shouldShowBack(pathname) && (
                <Link to="#" onClick={() => navigate(-1)}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                  >
                    <path
                      d="M13.75 5.5L8.25 11L13.75 16.5"
                      stroke="#6B6B6B"
                      stroke-width="2"
                    />
                  </svg>
                </Link>
              )}
              <h2>{getHeading(pathname)}</h2>
            </div>
            <div className="right-side-bar">
              <div className="notify-icon">
                <div className="notification-icon">
                  <Dropdown>
                    <Dropdown.Toggle
                      variant="success"
                      id="dropdown-basic"
                      style={{ position: "relative" }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        viewBox="0 0 22 23"
                        fill="none"
                      >
                        <path
                          d="M11 3.5C8.2 3.5 5.8 5.5 5.8 8.2V10.7C5.8 11.3 5.5 12.1 5.2 12.6L4.1 14.4C3.4 15.5 4 16.8 5.3 17.1H16.7C18 16.8 18.6 15.5 17.9 14.4L16.8 12.6C16.5 12.1 16.2 11.3 16.2 10.7V8.2C16.2 5.5 13.8 3.5 11 3.5Z"
                          stroke="#343637"
                          strokeWidth="1.5"
                          strokeMiterlimit="10"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M12.7 17.1C12.7 17.9 12.4 18.6 11.9 19.1C11.4 19.6 10.7 20 10 20C9.3 20 8.6 19.7 8.1 19.2C7.6 18.7 7.3 18 7.3 17.1"
                          stroke="#343637"
                          strokeWidth="1.5"
                          strokeMiterlimit="10"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      {hasUnreadNotifications && (
                        <div
                          style={{
                            position: "absolute",
                            top: "-5px",
                            right: "-6px",
                            width: "18px",
                            height: "18px",
                            backgroundColor: "red",
                            borderRadius: "50%",
                            border: "1px solid white",
                            color: "white",
                            fontSize: "10px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            lineHeight: "8px",
                          }}
                        >
                          {notifications.filter((n) => !n.isRead).length}
                        </div>
                      )}
                    </Dropdown.Toggle>

                    <Dropdown.Menu className="notifiaction">
                      <Dropdown.Item className="">
                        <div className="notify-head">
                          <p>Notifications</p>
                          {hasUnreadNotifications && (
                            <span>
                              {notifications.filter((n) => !n.isRead).length}{" "}
                              New
                            </span>
                          )}
                        </div>
                      </Dropdown.Item>

                      {notifications?.length > 0 ? (
                        notifications.map((item, i) => {
                          if (item?.notificationType === "SongRequest") {
                            return (
                              <Dropdown.Item
                                className={`drop-pro-view ${!item.isRead ? "notification_active" : ""
                                  }`}
                                key={i}
                              >
                                <div
                                  className="drop-pro-view"
                                  onClick={() => {
                                    markAsRead(i, item?._id);
                                    navigate(
                                      `/events-details/${Encryptedid(
                                        item?.event
                                      )}?clientId=${item?.client}`
                                    );
                                  }}
                                >
                                  <div className="user-notfic-icon">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                    >
                                      <g clip-path="url(#clip0_82_8485)">
                                        <path
                                          d="M19.6741 2.75827C18.4071 1.70392 16.9354 0.923427 15.3519 0.465964C13.7683 0.00850183 12.1072 -0.116013 10.4731 0.100265C7.45016 0.492983 4.68998 2.02144 2.75302 4.37527C0.816057 6.72911 -0.152497 9.73188 0.0440236 12.7739C0.240544 15.8159 1.58741 18.6691 3.81114 20.7541C6.03486 22.8392 8.96876 23.9998 12.0171 24.0003H18.9991C20.3247 23.9987 21.5955 23.4714 22.5329 22.534C23.4702 21.5967 23.9975 20.3259 23.9991 19.0003V11.2463C23.8933 9.61171 23.4551 8.01592 22.7115 6.55648C21.9678 5.09704 20.9343 3.80462 19.6741 2.75827ZM7.9991 7.00027H11.9991C12.2643 7.00027 12.5187 7.10562 12.7062 7.29316C12.8937 7.4807 12.9991 7.73505 12.9991 8.00027C12.9991 8.26548 12.8937 8.51984 12.7062 8.70737C12.5187 8.89491 12.2643 9.00027 11.9991 9.00027H7.9991C7.73388 9.00027 7.47953 8.89491 7.29199 8.70737C7.10446 8.51984 6.9991 8.26548 6.9991 8.00027C6.9991 7.73505 7.10446 7.4807 7.29199 7.29316C7.47953 7.10562 7.73388 7.00027 7.9991 7.00027ZM15.9991 17.0003H7.9991C7.73388 17.0003 7.47953 16.8949 7.29199 16.7074C7.10446 16.5198 6.9991 16.2655 6.9991 16.0003C6.9991 15.7351 7.10446 15.4807 7.29199 15.2932C7.47953 15.1056 7.73388 15.0003 7.9991 15.0003H15.9991C16.2643 15.0003 16.5187 15.1056 16.7062 15.2932C16.8937 15.4807 16.9991 15.7351 16.9991 16.0003C16.9991 16.2655 16.8937 16.5198 16.7062 16.7074C16.5187 16.8949 16.2643 17.0003 15.9991 17.0003ZM15.9991 13.0003H7.9991C7.73388 13.0003 7.47953 12.8949 7.29199 12.7074C7.10446 12.5198 6.9991 12.2655 6.9991 12.0003C6.9991 11.7351 7.10446 11.4807 7.29199 11.2932C7.47953 11.1056 7.73388 11.0003 7.9991 11.0003H15.9991C16.2643 11.0003 16.5187 11.1056 16.7062 11.2932C16.8937 11.4807 16.9991 11.7351 16.9991 12.0003C16.9991 12.2655 16.8937 12.5198 16.7062 12.7074C16.5187 12.8949 16.2643 13.0003 15.9991 13.0003Z"
                                          fill="#132027"
                                        />
                                      </g>
                                      <defs>
                                        <clipPath id="clip0_82_8485">
                                          <rect
                                            width="24"
                                            height="24"
                                            fill="white"
                                          />
                                        </clipPath>
                                      </defs>
                                    </svg>
                                  </div>
                                  <div className="notification-box">
                                    <p>{item?.body}</p>
                                  </div>
                                </div>
                              </Dropdown.Item>
                            );
                          }
                          if (item?.notificationType === "Payment") {
                            return (
                              <Dropdown.Item
                                className={`drop-pro-view ${!item.isRead ? "notification_active" : ""
                                  }`}
                                key={i}
                              >
                                <div
                                  className="drop-pro-view"
                                  onClick={() => {
                                    markAsRead(i, item?._id);
                                    navigate("/transactions");
                                  }}
                                >
                                  <div className="user-notfic-icon">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                    >
                                      <path
                                        d="M11.9994 0C11.2322 0 10.6811 0.486857 10.2114 0.899143C9.74166 1.31143 9.33023 1.65943 8.93509 1.71943C8.5438 1.77857 7.77923 1.38 7.0438 0.990429C6.67652 0.795429 6.31523 0.610286 5.91837 0.551572C5.52109 0.492857 5.03037 0.654429 4.77837 1.059C4.41237 1.64486 4.57266 2.34086 4.90694 2.91643C5.24123 3.49157 5.75766 4.03157 6.29809 4.51671C7.37937 5.48743 8.5768 6.23014 8.5768 6.23014C8.64454 6.27248 8.72277 6.29505 8.80266 6.29529H15.1952C15.2756 6.29529 15.3543 6.27271 15.4224 6.23014C15.4224 6.23014 16.6185 5.48743 17.6998 4.51671C18.2398 4.03157 18.7567 3.49157 19.0909 2.91643C19.4252 2.34086 19.5855 1.64486 19.2195 1.059C18.9675 0.654 18.4768 0.492857 18.0795 0.551572C17.6827 0.610286 17.3214 0.795429 16.9541 0.990429C16.2187 1.38 15.4541 1.77857 15.0628 1.719C14.6677 1.65943 14.2562 1.31143 13.7865 0.899143C13.3168 0.486857 12.7665 0 11.9994 0ZM8.8078 7.15286C8.75415 7.15267 8.70094 7.16255 8.65094 7.182C6.80809 7.90329 5.3098 9.62914 4.2508 11.6469C3.1918 13.6646 2.5708 15.9874 2.5708 18C2.5708 20.6014 3.7048 22.2099 5.45209 23.0374C7.19937 23.865 9.49652 24 11.9994 24C14.5022 24 16.7994 23.865 18.5467 23.0374C20.2939 22.2099 21.4279 20.601 21.4279 18C21.4279 15.9874 20.8065 13.6646 19.7471 11.6469C18.6881 9.62914 17.1902 7.90329 15.3469 7.182C15.2972 7.16251 15.2443 7.15248 15.1909 7.15243L8.8078 7.15286ZM12.6714 12.5083C13.1511 12.5081 13.621 12.6449 14.0257 12.9026C14.1517 12.9651 14.2228 13.062 14.2399 13.194C14.2514 13.2578 14.2481 13.3234 14.2303 13.3857C14.2125 13.4481 14.1806 13.5055 14.1371 13.5536C14.1098 13.5936 14.0743 13.6273 14.0329 13.6525C13.9915 13.6776 13.9452 13.6936 13.8971 13.6993C13.7998 13.7109 13.6999 13.6907 13.5971 13.6393C13.4614 13.5515 13.3145 13.4823 13.1604 13.4336C13.0025 13.3825 12.8377 13.3565 12.6718 13.3564C12.2775 13.3564 11.9252 13.4507 11.6167 13.6393C11.3081 13.8279 11.0659 14.0876 10.8885 14.4193C10.8602 14.4724 10.8384 14.5299 10.8148 14.5864L12.1399 14.5907C12.2655 14.5907 12.3688 14.6306 12.4485 14.7107C12.5342 14.7849 12.5771 14.8817 12.5771 15.0017C12.5771 15.1217 12.5342 15.222 12.4485 15.3021C12.3688 15.3763 12.2655 15.4136 12.1399 15.4136L10.6391 15.4084C10.6365 15.459 10.6318 15.507 10.6318 15.5593C10.6318 15.6583 10.6382 15.7521 10.6459 15.8456L12.1399 15.8503C12.2655 15.8503 12.3688 15.8876 12.4485 15.9617C12.5342 16.0363 12.5771 16.1331 12.5771 16.2531C12.5771 16.3731 12.5342 16.4734 12.4485 16.5536C12.408 16.5935 12.3597 16.6248 12.3066 16.6454C12.2535 16.666 12.1968 16.6756 12.1399 16.6736L10.8534 16.6693C10.8709 16.7074 10.8855 16.7481 10.9052 16.785C11.0882 17.1159 11.3338 17.3674 11.6424 17.5389C11.9509 17.7043 12.2942 17.7874 12.6714 17.7874C13.0001 17.7888 13.322 17.6936 13.5971 17.5136C13.6999 17.4621 13.7998 17.445 13.8971 17.4621C13.9939 17.4733 14.0771 17.5217 14.1457 17.6074C14.2369 17.7274 14.2712 17.8509 14.2485 17.9764C14.2258 18.0964 14.1542 18.1873 14.0342 18.2503C13.9007 18.3313 13.7601 18.4002 13.6142 18.456C13.4655 18.5134 13.3112 18.5589 13.1514 18.5931C12.9915 18.6274 12.8317 18.6446 12.6714 18.6446C12.2831 18.6446 11.9145 18.5764 11.5657 18.4393C11.2168 18.3021 10.9087 18.102 10.6399 17.8393C10.3712 17.5766 10.1599 17.2539 10.0057 16.8707C9.97909 16.8051 9.95809 16.7357 9.93623 16.6667L9.46566 16.665C9.34009 16.665 9.23423 16.6251 9.14851 16.545C9.06837 16.4653 9.02852 16.365 9.02852 16.245C9.02852 16.125 9.06837 16.0277 9.14851 15.9536C9.23423 15.879 9.34009 15.8421 9.46566 15.8421L9.78537 15.843C9.7787 15.7486 9.77513 15.6539 9.77466 15.5593C9.77466 15.507 9.77894 15.4569 9.78109 15.4059L9.46566 15.405C9.34978 15.4085 9.23674 15.3688 9.14851 15.2936C9.06837 15.2139 9.02852 15.1136 9.02852 14.9936C9.02852 14.8736 9.06837 14.7763 9.14851 14.7021C9.23423 14.622 9.33966 14.5821 9.46566 14.5821L9.90923 14.5839C10.0383 14.1312 10.2742 13.7161 10.5971 13.3736C10.8563 13.1018 11.1684 12.8859 11.5142 12.7393C11.8682 12.585 12.2544 12.5083 12.6714 12.5083Z"
                                        fill="#132027"
                                      />
                                    </svg>
                                  </div>
                                  <div className="notification-box">
                                    <p>{item?.body}</p>
                                  </div>
                                </div>
                              </Dropdown.Item>
                            );
                          }
                          if (item?.notificationType === "request_change") {
                            return (
                              <Dropdown.Item
                                className={`drop-pro-view ${!item.isRead ? "notification_active" : ""
                                  }`}
                                key={i}
                              >
                                <div
                                  className="drop-pro-view"
                                  onClick={() => {
                                    markAsRead(i, item?._id);
                                    navigate("/requestchanges");
                                  }}
                                >
                                  <div className="user-notfic-icon">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                    >
                                      <path
                                        d="M11.9994 0C11.2322 0 10.6811 0.486857 10.2114 0.899143C9.74166 1.31143 9.33023 1.65943 8.93509 1.71943C8.5438 1.77857 7.77923 1.38 7.0438 0.990429C6.67652 0.795429 6.31523 0.610286 5.91837 0.551572C5.52109 0.492857 5.03037 0.654429 4.77837 1.059C4.41237 1.64486 4.57266 2.34086 4.90694 2.91643C5.24123 3.49157 5.75766 4.03157 6.29809 4.51671C7.37937 5.48743 8.5768 6.23014 8.5768 6.23014C8.64454 6.27248 8.72277 6.29505 8.80266 6.29529H15.1952C15.2756 6.29529 15.3543 6.27271 15.4224 6.23014C15.4224 6.23014 16.6185 5.48743 17.6998 4.51671C18.2398 4.03157 18.7567 3.49157 19.0909 2.91643C19.4252 2.34086 19.5855 1.64486 19.2195 1.059C18.9675 0.654 18.4768 0.492857 18.0795 0.551572C17.6827 0.610286 17.3214 0.795429 16.9541 0.990429C16.2187 1.38 15.4541 1.77857 15.0628 1.719C14.6677 1.65943 14.2562 1.31143 13.7865 0.899143C13.3168 0.486857 12.7665 0 11.9994 0ZM8.8078 7.15286C8.75415 7.15267 8.70094 7.16255 8.65094 7.182C6.80809 7.90329 5.3098 9.62914 4.2508 11.6469C3.1918 13.6646 2.5708 15.9874 2.5708 18C2.5708 20.6014 3.7048 22.2099 5.45209 23.0374C7.19937 23.865 9.49652 24 11.9994 24C14.5022 24 16.7994 23.865 18.5467 23.0374C20.2939 22.2099 21.4279 20.601 21.4279 18C21.4279 15.9874 20.8065 13.6646 19.7471 11.6469C18.6881 9.62914 17.1902 7.90329 15.3469 7.182C15.2972 7.16251 15.2443 7.15248 15.1909 7.15243L8.8078 7.15286ZM12.6714 12.5083C13.1511 12.5081 13.621 12.6449 14.0257 12.9026C14.1517 12.9651 14.2228 13.062 14.2399 13.194C14.2514 13.2578 14.2481 13.3234 14.2303 13.3857C14.2125 13.4481 14.1806 13.5055 14.1371 13.5536C14.1098 13.5936 14.0743 13.6273 14.0329 13.6525C13.9915 13.6776 13.9452 13.6936 13.8971 13.6993C13.7998 13.7109 13.6999 13.6907 13.5971 13.6393C13.4614 13.5515 13.3145 13.4823 13.1604 13.4336C13.0025 13.3825 12.8377 13.3565 12.6718 13.3564C12.2775 13.3564 11.9252 13.4507 11.6167 13.6393C11.3081 13.8279 11.0659 14.0876 10.8885 14.4193C10.8602 14.4724 10.8384 14.5299 10.8148 14.5864L12.1399 14.5907C12.2655 14.5907 12.3688 14.6306 12.4485 14.7107C12.5342 14.7849 12.5771 14.8817 12.5771 15.0017C12.5771 15.1217 12.5342 15.222 12.4485 15.3021C12.3688 15.3763 12.2655 15.4136 12.1399 15.4136L10.6391 15.4084C10.6365 15.459 10.6318 15.507 10.6318 15.5593C10.6318 15.6583 10.6382 15.7521 10.6459 15.8456L12.1399 15.8503C12.2655 15.8503 12.3688 15.8876 12.4485 15.9617C12.5342 16.0363 12.5771 16.1331 12.5771 16.2531C12.5771 16.3731 12.5342 16.4734 12.4485 16.5536C12.408 16.5935 12.3597 16.6248 12.3066 16.6454C12.2535 16.666 12.1968 16.6756 12.1399 16.6736L10.8534 16.6693C10.8709 16.7074 10.8855 16.7481 10.9052 16.785C11.0882 17.1159 11.3338 17.3674 11.6424 17.5389C11.9509 17.7043 12.2942 17.7874 12.6714 17.7874C13.0001 17.7888 13.322 17.6936 13.5971 17.5136C13.6999 17.4621 13.7998 17.445 13.8971 17.4621C13.9939 17.4733 14.0771 17.5217 14.1457 17.6074C14.2369 17.7274 14.2712 17.8509 14.2485 17.9764C14.2258 18.0964 14.1542 18.1873 14.0342 18.2503C13.9007 18.3313 13.7601 18.4002 13.6142 18.456C13.4655 18.5134 13.3112 18.5589 13.1514 18.5931C12.9915 18.6274 12.8317 18.6446 12.6714 18.6446C12.2831 18.6446 11.9145 18.5764 11.5657 18.4393C11.2168 18.3021 10.9087 18.102 10.6399 17.8393C10.3712 17.5766 10.1599 17.2539 10.0057 16.8707C9.97909 16.8051 9.95809 16.7357 9.93623 16.6667L9.46566 16.665C9.34009 16.665 9.23423 16.6251 9.14851 16.545C9.06837 16.4653 9.02852 16.365 9.02852 16.245C9.02852 16.125 9.06837 16.0277 9.14851 15.9536C9.23423 15.879 9.34009 15.8421 9.46566 15.8421L9.78537 15.843C9.7787 15.7486 9.77513 15.6539 9.77466 15.5593C9.77466 15.507 9.77894 15.4569 9.78109 15.4059L9.46566 15.405C9.34978 15.4085 9.23674 15.3688 9.14851 15.2936C9.06837 15.2139 9.02852 15.1136 9.02852 14.9936C9.02852 14.8736 9.06837 14.7763 9.14851 14.7021C9.23423 14.622 9.33966 14.5821 9.46566 14.5821L9.90923 14.5839C10.0383 14.1312 10.2742 13.7161 10.5971 13.3736C10.8563 13.1018 11.1684 12.8859 11.5142 12.7393C11.8682 12.585 12.2544 12.5083 12.6714 12.5083Z"
                                        fill="#132027"
                                      />
                                    </svg>
                                  </div>
                                  <div className="notification-box">
                                    <p>{item?.body}</p>
                                  </div>
                                </div>
                              </Dropdown.Item>
                            );
                          }
                        })
                      ) : (
                        <Dropdown.Item className="">
                          <div className="drop-pro-view">
                            <div className="user-notfic-icon">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <g clip-path="url(#clip0_82_8485)">
                                  <path
                                    d="M19.6741 2.75827C18.4071 1.70392 16.9354 0.923427 15.3519 0.465964C13.7683 0.00850183 12.1072 -0.116013 10.4731 0.100265C7.45016 0.492983 4.68998 2.02144 2.75302 4.37527C0.816057 6.72911 -0.152497 9.73188 0.0440236 12.7739C0.240544 15.8159 1.58741 18.6691 3.81114 20.7541C6.03486 22.8392 8.96876 23.9998 12.0171 24.0003H18.9991C20.3247 23.9987 21.5955 23.4714 22.5329 22.534C23.4702 21.5967 23.9975 20.3259 23.9991 19.0003V11.2463C23.8933 9.61171 23.4551 8.01592 22.7115 6.55648C21.9678 5.09704 20.9343 3.80462 19.6741 2.75827ZM7.9991 7.00027H11.9991C12.2643 7.00027 12.5187 7.10562 12.7062 7.29316C12.8937 7.4807 12.9991 7.73505 12.9991 8.00027C12.9991 8.26548 12.8937 8.51984 12.7062 8.70737C12.5187 8.89491 12.2643 9.00027 11.9991 9.00027H7.9991C7.73388 9.00027 7.47953 8.89491 7.29199 8.70737C7.10446 8.51984 6.9991 8.26548 6.9991 8.00027C6.9991 7.73505 7.10446 7.4807 7.29199 7.29316C7.47953 7.10562 7.73388 7.00027 7.9991 7.00027ZM15.9991 17.0003H7.9991C7.73388 17.0003 7.47953 16.8949 7.29199 16.7074C7.10446 16.5198 6.9991 16.2655 6.9991 16.0003C6.9991 15.7351 7.10446 15.4807 7.29199 15.2932C7.47953 15.1056 7.73388 15.0003 7.9991 15.0003H15.9991C16.2643 15.0003 16.5187 15.1056 16.7062 15.2932C16.8937 15.4807 16.9991 15.7351 16.9991 16.0003C16.9991 16.2655 16.8937 16.5198 16.7062 16.7074C16.5187 16.8949 16.2643 17.0003 15.9991 17.0003ZM15.9991 13.0003H7.9991C7.73388 13.0003 7.47953 12.8949 7.29199 12.7074C7.10446 12.5198 6.9991 12.2655 6.9991 12.0003C6.9991 11.7351 7.10446 11.4807 7.29199 11.2932C7.47953 11.1056 7.73388 11.0003 7.9991 11.0003H15.9991C16.2643 11.0003 16.5187 11.1056 16.7062 11.2932C16.8937 11.4807 16.9991 11.7351 16.9991 12.0003C16.9991 12.2655 16.8937 12.5198 16.7062 12.7074C16.5187 12.8949 16.2643 13.0003 15.9991 13.0003Z"
                                    fill="#132027"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_82_8485">
                                    <rect width="24" height="24" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                            </div>
                            <div className="notification-box">
                              <p>No Notifications</p>
                            </div>
                          </div>
                        </Dropdown.Item>
                      )}
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
              <div className="user-img-top">
                <div className="drop-pro-view align-items-center">
                  <img
                    width={40}
                    height={40}
                    style={{ cursor: "pointer" }}
                    className="rounded-5 object-cover"
                    src={
                      getInfo?.image
                        ? getInfo?.image
                        : require("../Assets/Images/user-placeholder.png")
                    }
                    onClick={(e) => {
                      e.stopPropagation();
                      document.getElementById("file-input").click();
                    }}
                  />
                  <input
                    id="file-input"
                    type="file"
                    accept="image/*"
                    style={{ display: "none" }}
                    onChange={handleFileChange}
                  />
                </div>
                <Dropdown>
                  <Dropdown.Toggle variant="success" id="dropdown-basic" >
                    {/* <div className="drop-pro-view align-items-center"> */}

                    <div className="admin-name">
                      <h3>{capitalize(getInfo?.fullName)}</h3>
                      <p>{getInfo?.email}</p>
                    </div>
                    {/* </div> */}

                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <div className="my-profile">
                      <Dropdown.Item>
                        <Link to="/changepassword" className="text-decoration-none">

                          <svg
                            version="1.1"
                            id="Layer_1"
                            xmlns="http://www.w3.org/2000/svg"
                            x="0px"
                            y="0px"
                            width="22"
                            height="22"
                            viewBox="0 0 122.879 118.662"
                            enableBackground="new 0 0 122.879 118.662"
                            xmlSpace="preserve"
                          >
                            <g>
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                fill="none"
                                stroke="#808080"
                                strokeWidth="2"
                                d="M43.101,54.363h4.138v-8.738c0-4.714,1.93-8.999,5.034-12.105v-0.004 c3.105-3.105,7.392-5.034,12.108-5.034c4.714,0,8.999,1.929,12.104,5.034l0.004,0.004c3.104,3.105,5.034,7.392,5.034,12.104v8.738 l3.297,0.001c0.734,0,1.335,0.601,1.335,1.335v28.203c0,0.734-0.602,1.335-1.336,1.335H43.101c-0.734,0-1.336-0.602-1.336-1.335 V55.698C41.765,54.964,42.366,54.363,43.101,54.363L43.101,54.363z M16.682,22.204c-1.781,2.207-3.426,4.551-5.061,7.457 c-5.987,10.645-8.523,22.731-7.49,34.543c1.01,11.537,5.432,22.827,13.375,32.271c2.853,3.392,5.914,6.382,9.132,8.968 c11.112,8.935,24.276,13.341,37.405,13.216c13.134-0.125,26.209-4.784,37.145-13.981c3.189-2.682,6.179-5.727,8.915-9.13 c6.396-7.957,10.512-17.29,12.071-27.138c1.532-9.672,0.595-19.829-3.069-29.655c-3.487-9.355-8.814-17.685-15.775-24.206 C96.695,8.333,88.593,3.755,79.196,1.483c-2.943-0.712-5.939-1.177-8.991-1.374c-3.062-0.197-6.193-0.131-9.401,0.224 c-2.011,0.222-3.459,2.03-3.238,4.041c0.222,2.01,2.03,3.459,4.04,3.237c2.783-0.308,5.495-0.366,8.141-0.195 c2.654,0.171,5.23,0.568,7.731,1.174c8.106,1.959,15.104,5.914,20.838,11.288c6.138,5.751,10.847,13.125,13.941,21.427 c3.212,8.613,4.035,17.505,2.696,25.959c-1.36,8.589-4.957,16.739-10.553,23.699c-2.469,3.071-5.121,5.78-7.912,8.127 c-9.591,8.067-21.031,12.153-32.502,12.263c-11.473,0.109-23.001-3.762-32.764-11.61c-2.895-2.328-5.621-4.983-8.129-7.966 c-6.917-8.224-10.771-18.092-11.655-28.202c-0.908-10.375,1.317-20.988,6.572-30.331c1.586-2.82,3.211-5.071,5.013-7.241 l0.533,14.696c0.071,2.018,1.765,3.596,3.782,3.524s3.596-1.765,3.524-3.782l-0.85-23.419c-0.071-2.019-1.765-3.596-3.782-3.525 c-0.126,0.005-0.25,0.016-0.372,0.032v-0.003L3.157,16.715c-2.001,0.277-3.399,2.125-3.122,4.126 c0.276,2.002,2.124,3.4,4.126,3.123L16.682,22.204L16.682,22.204L16.682,22.204z M53.899,54.363h20.963v-8.834 c0-2.883-1.18-5.504-3.077-7.403l-0.002,0.001c-1.899-1.899-4.521-3.08-7.402-3.08c-2.883,0-5.504,1.18-7.404,3.078 c-1.898,1.899-3.077,4.521-3.077,7.404V54.363L53.899,54.363L53.899,54.363z M64.465,69.795l2.116,9.764l-5.799,0.024l1.701-9.895 c-1.584-0.509-2.733-1.993-2.733-3.747c0-2.171,1.76-3.931,3.932-3.931c2.17,0,3.931,1.76,3.931,3.931 C67.612,67.845,66.261,69.433,64.465,69.795L64.465,69.795L64.465,69.795z"
                              />
                            </g>
                          </svg>
                          Update Password
                        </Link>
                      </Dropdown.Item>
                    </div>

                    {/* <div className="my-profile">
                      <Dropdown.Item href="/" className="text-danger">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                        >
                          <path
                            d="M13 15.625C12.9264 17.4769 11.3831 19.0494 9.31564 18.9988C8.83465 18.987 8.24013 18.8194 7.05112 18.484C4.18961 17.6768 1.70555 16.3203 1.10956 13.2815C1 12.723 1 12.0944 1 10.8373L1 9.16274C1 7.90561 1 7.27705 1.10956 6.71846C1.70555 3.67965 4.18961 2.32316 7.05112 1.51603C8.24014 1.18064 8.83465 1.01295 9.31564 1.00119C11.3831 0.95061 12.9264 2.52307 13 4.37501"
                            stroke="#BB1111"
                            stroke-linecap="round"
                          />
                          <path
                            d="M19 10H8M19 10C19 9.29977 17.0057 7.99153 16.5 7.5M19 10C19 10.7002 17.0057 12.0085 16.5 12.5"
                            stroke="#BB1111"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        Logout
                      </Dropdown.Item>
                    </div> */}
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              <div class="hamburger-menu-btn" onClick={hideUnhide}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 48 48"
                  width="35px"
                  height="35px"
                >
                  <path
                    fill="#000"
                    d="M6 22H42V26H6zM6 10H42V14H6zM6 34H42V38H6z"
                  ></path>
                </svg>
              </div>
            </div>
          </div>
          {!shouldHideSearch(pathname) && (
            <div className="right-top-bar px-3 py-2 mt-3">
              <div className="left-side-bar ">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    d="M7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667Z"
                    stroke="#9F9EA1"
                    stroke-width="1.33333"
                    stroke-linecap="square"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M14.0001 14L11.1001 11.1"
                    stroke="#9F9EA1"
                    stroke-width="1.33333"
                    stroke-linecap="square"
                    stroke-linejoin="round"
                  />
                </svg>
                <SearchComponent
                  heading={getHeading(pathname)}
                  pathname={pathname}
                />
              </div>
            </div>
          )}
        </div>
      </Container>
    </div>
  );
};

export default TopHeader;
